import { FC } from 'react';
import { ArrowForward } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';
import { DailyNavConfigDiffProps } from './DailyNavConfigDiff.props';

// A field-level "what changed" list: a version id tells an operator nothing, "Long
// Window Δ 10% → 12%" does. Presentational only -- callers build their own rows via
// buildDailyNavFirmConfigDiff.
const DailyNavConfigDiff: FC<DailyNavConfigDiffProps> = ({
  rows,
  fromLabel = 'Currently in effect',
  toLabel = 'After applying',
  emptyMessage,
  testId = 'daily-nav-config-diff',
}) => {
  if (!rows.length) {
    return emptyMessage ? (
      <Typography variant="body2" color="text.secondary" data-testid={`${testId}-empty`}>
        {emptyMessage}
      </Typography>
    ) : null;
  }

  return (
    <Box data-testid={testId}>
      <Stack direction="row" spacing={1} sx={{ mb: 0.5 }}>
        <Typography variant="caption" fontWeight="bold" color="text.secondary" sx={{ flex: 1 }}>
          {fromLabel.toUpperCase()}
        </Typography>
        {/* Spacer matching the arrow column. */}
        <Box sx={{ width: 24 }} />
        <Typography variant="caption" fontWeight="bold" color="text.secondary" sx={{ flex: 1 }}>
          {toLabel.toUpperCase()}
        </Typography>
      </Stack>
      {rows.map(row => (
        <Box key={row.key} sx={{ mb: 1 }} data-testid={`${testId}-row-${row.key}`}>
          <Typography variant="caption" color="text.secondary">
            {row.label}
          </Typography>
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="body2" sx={{ flex: 1 }}>
              {row.from}
            </Typography>
            {/* Decorative: the column headings already say which side is which. */}
            <ArrowForward aria-hidden fontSize="small" sx={{ width: 24, color: 'text.disabled' }} />
            <Typography variant="body2" fontWeight="bold" sx={{ flex: 1 }}>
              {row.to}
            </Typography>
          </Stack>
        </Box>
      ))}
    </Box>
  );
};

export default DailyNavConfigDiff;
